import React from "react"
// import {Link} from "react-router-dom"
import styles from "../compStyles/navBarDrawerModel.module.css"
import { Link, animateScroll as scroll } from 'react-scroll';

const NavBarDrawerModel=(prop)=>{

    const handleDownload = () => {
        // Replace 'your-pdf-url' with the actual URL of your PDF file
        const pdfUrl = './';
        // Create a temporary anchor element
        const link = document.createElement('a');
        // Set the href attribute to the PDF URL
        link.href = pdfUrl;
        // Set the download attribute to force download
        link.setAttribute('download', 'Raj_Gupta_Resume.pdf');
        // Append the anchor element to the body
        document.body.appendChild(link);
        // Trigger a click on the anchor element
        link.click();
        // Remove the anchor element from the body
        document.body.removeChild(link);
      };


return(
    <div onClick={()=>prop.setMobileMenu(false)}   className={prop.mobileMenu ?styles.back:""}>
    <div className={prop.mobileMenu ? styles.drawerContainer_open : styles.drawerContainer}>
        <div className={styles.drawerContent}>
            <div className={prop.mobileMenu ? styles.navbar_menu:styles.navRight}>
                    <div> <Link to="container"  className={styles.linkTag} spy={true} smooth={true} offset={-70} duration={500}  > <h3>Home</h3></Link> </div>
                    <hr/>
                    <div> <Link to="about" className={styles.linkTag}  spy={true} smooth={true} offset={-70} duration={500}> <h3>About Me</h3></Link></div>
                    <hr/>
                    <div> <Link to="skills" className={styles.linkTag} spy={true} smooth={true} offset={-70} duration={500} >  <h3>Skills</h3></Link>  </div>
                    <hr/>
                    <div> <Link to="projects" className={styles.linkTag} spy={true} smooth={true} offset={-70} duration={500} >  <h3>Projects</h3> </Link> </div>
                    <hr/>
                    <div> <Link to="contact"  className={styles.linkTag} spy={true} smooth={true} offset={-70} duration={500} >  <h3>Contact</h3> </Link> </div>
                    <hr/>
                    <div onClick={handleDownload}> <a href="https://drive.google.com/file/d/1t1Mu2gSaumKBlH_aOplZBDtwG9F2k8Vs/view?usp=sharing"  className={styles.linkTag} target="blank"  >  <h3>Resume</h3> </a> </div>
                    <hr/>
            </div>
        </div>
        
    </div>  
     </div>
)

}

export default NavBarDrawerModel